<tt-page *ngIf="page" class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input class="col-xs-12 sp-0" ttLabel="vt_keyno" [ttModel]="page.vt_keyno" ttReadonly></tt-input>
    </tt-card>
    <tt-grid *ngIf="grid" class="col-xs-12 sp-0 flex-1" [ttOptions]="grid"></tt-grid>
    <tt-grid *ngIf="gridVtLang" class="col-xs-12 sp-0 flex-1" [ttOptions]="gridVtLang"></tt-grid>
    <tt-grid *ngIf="gridVtLink" class="col-xs-12 sp-0 flex-1" [ttOptions]="gridVtLink"></tt-grid>
</tt-page>
